import React from "react";
import PropTypes from "prop-types";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { CmsContent } from "@cars24/turbo-web/lib/cms-content";
import Vector from "./images/vector.svg";
import styles from "./styles.css";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { sendCustomGaEvents } from "../../../tracking";
import { pdiReadMoreClicked } from "../../../constants/tracking-constants/pre-delivery-inspection";

const PreDeliveryInspectionDetails = ({
    details
}) => {

    const {
        description = ""
    } = details?.sectionData || {};

    const { tokens } = useTokens();

    const onViewChange = async (expanded) => {
        if (expanded) {
            await yieldToMain();
            sendCustomGaEvents(pdiReadMoreClicked);
        }
    };

    return (
        <div styleName={"styles.detailsWrapper"} id="why-pre-delivery-inspection">
            <CmsContent
                content={description}
                isExpandable={(description || "").length > 0}
                expandedText={"Read less"}
                collapsedText={"Read more"}
                lineCount={4}
                onViewChange={onViewChange}
                color={tokens.text_default_text_secondary}
                suffixIcon={<img src={Vector} alt={"arrow"} />}
                expandVariant="brand"
            />
        </div>);
};

PreDeliveryInspectionDetails.propTypes = {
    details: PropTypes.object
};

export default PreDeliveryInspectionDetails;
